import * as React from "react";

export const IconAddCircleOutline = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      d="M10.8332 5.83464H9.1665V9.16797H5.83317V10.8346H9.1665V14.168H10.8332V10.8346H14.1665V9.16797H10.8332V5.83464ZM9.99984 1.66797C5.39984 1.66797 1.6665 5.4013 1.6665 10.0013C1.6665 14.6013 5.39984 18.3346 9.99984 18.3346C14.5998 18.3346 18.3332 14.6013 18.3332 10.0013C18.3332 5.4013 14.5998 1.66797 9.99984 1.66797ZM9.99984 16.668C6.32484 16.668 3.33317 13.6763 3.33317 10.0013C3.33317 6.3263 6.32484 3.33464 9.99984 3.33464C13.6748 3.33464 16.6665 6.3263 16.6665 10.0013C16.6665 13.6763 13.6748 16.668 9.99984 16.668Z"
      fill="currentColor"
    />
  </svg>
);
